/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { MoreVert } from "@mui/icons-material";
import useApi from "../../../../../utils/api-manager/Helper/useApi";
import StoreCashTable from "./StoreCashTable";
import "./style.css"; // Import the CSS file

const StoreCashBalance = () => {
  const [storeData, setStoreData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [otherStoreCash, setOtherStoreCash] = useState(null);

  const { Get } = useApi();

  useEffect(() => {
    const fetchDashboardCashBalance = () => {
      setLoading(true);

      Get("dashboardCashBalance") // Call the API
        .then((response) => {
          // On success, set the response data
          setStoreData(response);
          setOtherStoreCash(response.additional_stores);
          setLoading(false);
        })
        .catch((err) => {
          // Handle any errors
          setError("Failed to fetch data");
          console.error(err);
          setLoading(false);
        });
    };

    fetchDashboardCashBalance();
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <div className="store-cash-balance">
      <div className="header">
        <h6 className="header-title">
          Current Store Cash <br />
          Balance
        </h6>
      </div>

      <div className="cash-info">
        <div className="cash-info-header">
          <span className="cash-info-title">USD Amount</span>
          <button className="more-button">
            <MoreVert />
          </button>
        </div>

        <div className="cash-info-details">
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p className="error">{error}</p>
          ) : (
            <>
              <h6 className="store-name">{storeData?.store_name || "N/A"}</h6>

              <div className="store-details">
                <p className="store-address">{storeData?.address || "N/A"}</p>

                <h6 className="store-cash-amount">
                  ${storeData?.total_current_cash?.toLocaleString() || "0.00"}
                </h6>
              </div>
            </>
          )}
        </div>
      </div>
      <StoreCashTable otherStoreCash={otherStoreCash} />
    </div>
  );
};

export default StoreCashBalance;
